var React = require('react');

function ArrowRightRound (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.0001 2.66675C8.64008 2.66675 2.66675 8.64008 2.66675 16.0001C2.66675 23.3601 8.64008 29.3334 16.0001 29.3334C23.3601 29.3334 29.3334 23.3601 29.3334 16.0001C29.3334 8.64008 23.3601 2.66675 16.0001 2.66675ZM21.3734 16.7067L17.3734 20.7067C17.1734 20.9067 16.9201 21.0001 16.6667 21.0001C16.4134 21.0001 16.1601 20.9067 15.9601 20.7067C15.5734 20.3201 15.5734 19.6801 15.9601 19.2934L18.2534 17.0001H11.3334C10.7867 17.0001 10.3334 16.5467 10.3334 16.0001C10.3334 15.4534 10.7867 15.0001 11.3334 15.0001H18.2534L15.9601 12.7067C15.5734 12.3201 15.5734 11.6801 15.9601 11.2934C16.3467 10.9067 16.9867 10.9067 17.3734 11.2934L21.3734 15.2934C21.7601 15.6801 21.7601 16.3201 21.3734 16.7067Z"}));
}

ArrowRightRound.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 32 32","fill":"currentColor"};

module.exports = ArrowRightRound;

ArrowRightRound.default = ArrowRightRound;
